<template>
  <f7-page>
    <div class="mx-auto w-11/12 sm:w-9/12 sm:min-w-150 mt-2 sm:mt-12 max-w-4xl">
      <div
        class="mx-auto my-10 sm:flex justify-between max-w-2xl"
      >
        <img
          class="w-24"
          src="@/assets/sensors.svg"
        >
        <div
          class="text-4xl font-bold mx-10"
        >
          Dispositivos control de acceso
        </div>
      </div>
      <div>
        <div class="flex space-x-2 justify-end flex-wrap">
          <a
            class="block bg-green-500 text-white text-center text-2xl rounded-md py-2 my-2"
            href="/admin/linkNetwork/"
          >Vincular +</a>
        </div>
      </div>
      <div
        v-if="devices.length > 0"
        class="flex flex-wrap flex-grow"
      >
        <div
          v-for="device in devices"
          :key="device.id"
          class="p-6 rounded-lg border border-gray-300 shadow-md min-w-64"
        >
          <div class="flex items-center">
            <div
              :class="`w-3 h-3 rounded-full bg-${isOnline(device) ? 'green-500' : 'red-500'} mr-4`"
            />
            <div
              class="text-xl font-bold mr-4 w-1/2"
            >
              {{ device.alias }}
            </div>
          </div>
          <div>MAC {{ device.mac }}</div>
        </div>
      </div>
      <div
        v-else
        class="text-center mt-16"
      >
        <img
          class="mx-auto w-3/6 opacity-50"
          src="@/assets/empty.svg"
          alt="Empty"
        >
        <div class="mt-4 text-lg text-center">
          ¡Vaya! Aun no tienes lectores vinculados, animate a automatizar y agilizar los ingresos.
        </div>
      </div>
    </div>
  </f7-page>
</template>

<script>
import { db } from '../utils/firebase'
import { mapState } from 'vuex'

export default {
  components: {
  },
  data () {
    return {
      devices: [],
    }
  },
  computed: {
    ...mapState({
      instanceID: state => state.admin.instanceID,
    }),
  },
  mounted () {
    db.collection('hardware').doc('sensors').collection('devices')
      .where('instanceID', '==', this.instanceID).onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          if (change.type === 'added') {
            this.devices.push({
              id: change.doc.id,
              ...change.doc.data(),
            })
          } else if (change.type === 'changed') {
            this.devices.splice(this.devices.findIndex(code => code.id === change.doc.id), 1, {
              id: change.doc.id,
              ...change.doc.data(),
            })
          } else if (change.type === 'removed') {
            this.devices = this.devices.filter(code => code.id !== change.doc.id)
          }
        })
      })
  },
  methods: {
    isOnline (device) {
      if (!device.heartbeat) return false
      return Date.now() - device.heartbeat.toMillis() < (1000 * 60 * 10)
    },
  },
}
</script>
